import React from 'react';
import {Image as ImageType} from '../../admin/artisticobjects/types/Image';
import AdminUploadedImage from "./AdminUploadedImage";
import {closestCenter, DndContext, KeyboardSensor, PointerSensor, useSensor, useSensors,} from '@dnd-kit/core';
import {arrayMove, rectSortingStrategy, SortableContext, sortableKeyboardCoordinates,} from '@dnd-kit/sortable';
import type {DragEndEvent} from "@dnd-kit/core/dist/types";

interface AdminUploadedImagesProps {
  images: ImageType[];
  onImageDelete: (imageId: string, imageName: string, e: React.MouseEvent<HTMLButtonElement>) => void;
  onImageEdit: (imageId: string, e: React.MouseEvent<HTMLButtonElement>) => void;
  onImageOrderChange: (images: ImageType[]) => void;
}

const AdminUploadedImages: React.FC<AdminUploadedImagesProps> = ({
                                                                   images,
                                                                   onImageDelete,
                                                                   onImageEdit,
                                                                   onImageOrderChange
                                                                 }) => {

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = (e: DragEndEvent) => {
    const {active, over} = e;

    if (over?.id &&active.id !== over.id) {

      const oldIndex = images.findIndex(image => image.id === active.id);
      const newIndex = images.findIndex(image => image.id === over.id);

      var sortedImages = arrayMove(images, oldIndex, newIndex)

      onImageOrderChange(sortedImages);
    }
  }

  if (!images || images.length === 0) {
    return null;
  }

  return (
    <div>
      <div className="grid grid-cols-2 gap-4">
        <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={handleDragEnd}
        >
          <SortableContext
            items={images}
            strategy={rectSortingStrategy}
          >
            {images.map((image) => (
              <AdminUploadedImage
                key={image.id}
                image={image}
                onImageDelete={onImageDelete}
                onImageEdit={onImageEdit}
              />
            ))}
          </SortableContext>
        </DndContext>
      </div>
    </div>
  );
};

export default AdminUploadedImages;
